export const initialValues = {
  id: "",
  name: "",
  description: "",
  actionPermissions: [],
};

// El código del rol es un dato interno (se usa solo como identificador
// único en el backend); el formulario ya no lo pide, se genera solo a
// partir del nombre mientras se está creando el rol.
export function generateRoleCode(name) {
  return String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 40);
}

export function getRolePayload(values = {}) {
  const actionPermissions = Array.isArray(values.actionPermissions)
    ? values.actionPermissions
    : [];

  // Un menú queda "visible" para el rol cuando tiene al menos una acción
  // marcada; no existe un checkbox de visibilidad aparte.
  const menuPermissions = Array.from(
    new Set(actionPermissions.map((actionKey) => actionKey.split(".")[0]))
  );

  return {
    id: String(values.id || "").trim().toUpperCase(),
    name: String(values.name || "").trim(),
    description: String(values.description || "").trim(),
    menuPermissions,
    actionPermissions,
  };
}
